import { FormElement } from '../../element/element.model';
import { InputError } from '@ebeihilfe/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

export const requiredErrors: InputError[] = [
  {
    errorCode: 'required',
    errorMessage: _('validation.error.required'),
  },
];

export const getRequiredErrors = (element: FormElement): InputError[] => {
  if (!element.isRequired) {
    return [];
  }

  return [
    {
      errorCode: requiredErrors[0].errorCode,
      errorMessage: FormElement.getRequiredErrorText(element) ?? requiredErrors[0].errorMessage,
    },
  ];
};
